import { useTranslation } from 'react-i18next'
import { RadioOptionPicker } from '../../../../components/common/Form/RadioOptionPicker/RadioOptionPicker'
import { Option } from '../../../../components/common/Form/types'
import * as React from 'react'
import { EmissionsScope } from '@/hooks'

export const EmissionScopeSelect: React.FC<{
    value: EmissionsScope
    onChange: (scope: EmissionsScope) => void
    disabled?: boolean
}> = (props) => {
    const { t } = useTranslation('translations')
    const { value, onChange, disabled } = props

    const options: Array<Option<EmissionsScope>> = [
        {
            value: 'all',
            label: t('sustainability.report_settings.emissionScope.all.label'),
            subtitle: t(
                'sustainability.report_settings.emissionScope.all.subtitle'
            ),
            disabled,
        },
        {
            value: 'scope1',
            label: t(
                'sustainability.report_settings.emissionScope.scope1.label'
            ),
            subtitle: t(
                'sustainability.report_settings.emissionScope.scope1.subtitle'
            ),
            disabled,
        },
        {
            value: 'scope2',
            label: t(
                'sustainability.report_settings.emissionScope.scope2.label'
            ),
            subtitle: t(
                'sustainability.report_settings.emissionScope.scope2.subtitle'
            ),
        },
    ]

    return (
        <RadioOptionPicker
            name="emission-scope"
            label={t('sustainability.report_settings.emissionScope.label')}
            value={value}
            options={options}
            onChange={(newValue: string) => {
                onChange(newValue as EmissionsScope)
            }}
            renderLabel={(option) => (
                <div className="flex flex-col">
                    <div className="text-label-small text-regular">
                        {option.label}
                    </div>
                    {option.subtitle && (
                        <div className="text-body-small font-normal text-subtle">
                            {option.subtitle}
                        </div>
                    )}
                </div>
            )}
        />
    )
}
